
import { Component } from "@angular/core";
import { ThemeService } from "../theme.service";

@Component({
    // tslint:disable-next-line: component-selector
    selector: "iti-shell-layout",
    styleUrls: ["./shell-layout.component.scss"],
    template: `
    <div>
        <div class="site-container">
            <iti-header></iti-header>
            <div id="site-pusher" style="background-color:#f2f3f8" class="site-pusher mb-5">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
  `,
})
export class ShellLayoutComponent {
    constructor(private themeService: ThemeService) {
    }
}